import Api_Mec from "./Api_Mec";

class MEC_Plantillas_api extends Api_Mec {
  constructor() {
    super();
  }

  insert(prmForm) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Plantillas/insert",
      prmForm,
      {}
    );
  }
  update(prmForm) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Plantillas/update",
      prmForm,
      {}
    );
  }
  delete(prmCriterio) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Plantillas/delete",
      { id_plantilla: prmCriterio },
      {}
    );
  }
  all(prmCriterio) {
    return this.post(
      this.url_api + "/MEC_API/MEC_Plantillas/all",
      { criterio_id_funcionario: prmCriterio },
      {}
    );
  }
  // find(prmOpt, prmCodAplicacion, prmEstado, prmCriterio, prmRI, prmRF){
  //     return this.post(this.url_api+'/MEC_API/MEC_Plantillas/list', {"prmOpt": prmOpt, "prmCodAplicacion": prmCodAplicacion, "prmEstado": prmEstado, "criterio": prmCriterio, "prmRI": prmRI, "prmRF":prmRF }, {});
  // }
  // get(prmCriterio){
  //     return this.get(this.url_api+'/MEC_API/MEC_Plantillas/get/'+prmCriterio, {});
  // }
}
export default MEC_Plantillas_api;
